import Link from 'next/link'

export default function Header() {
  return (
    <header className="bg-white shadow">
      <nav className="container mx-auto px-4 py-4">
        <div className="flex justify-between items-center">
          <Link href="/dashboard" className="text-xl font-bold text-primary">
            JLPT AI Tutor
          </Link>
          <div className="flex items-center gap-4">
            <Link 
              href="/learning-center" 
              className="text-gray-600 hover:text-primary"
            >
              學習中心
            </Link>
            <Link 
              href="/profile" 
              className="text-gray-600 hover:text-primary"
            >
              個人資料
            </Link>
          </div>
        </div>
      </nav>
    </header>
  )
}